import React, { forwardRef } from "react";
import "./retailMargin.css";
import EngineTool from "./EngineTool";
import markup from "../../lib/retailMarginMarkup";
import { mountRetailMargin } from "../../lib/retailMarginEngine";

// Native Retail Margin Calculator — snapshot format unchanged (every input id + __activeTab).
const RetailMarginTool = forwardRef(function RetailMarginTool({ onSave }, ref) {
  return <EngineTool ref={ref} markup={markup} mount={mountRetailMargin} className="rm-native"
    testid="retail-margin-native" onSave={onSave} />;
});

export default RetailMarginTool;
